import { render, staticRenderFns } from "./CustomizeChartData.vue?vue&type=template&id=6ecd39c4&scoped=true"
import script from "./CustomizeChartData.vue?vue&type=script&lang=js"
export * from "./CustomizeChartData.vue?vue&type=script&lang=js"
import style0 from "./CustomizeChartData.vue?vue&type=style&index=0&id=6ecd39c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd39c4",
  null
  
)

export default component.exports